import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { Dialog, Button, TextInput } from "hesus-ui-kit";
import BarLoader from "react-spinners/BarLoader";
import RelatedContact from "./RelatedContact";
import { Title, GridRow } from "../../AddEditQuote.styled";

import {
  HeaderWrapper,
  FormBody,
  OptionsWrapper,
  SectionContainer,
  ButtonWrapper,
} from "./RelatedContact.styled";
import { labelStyles, inputStyles } from "@utils/extra-style";

const AddRelatedContact = (props) => {
  const {
    t,
    companyId,
    onClose,
    selectedContacts,
    setSelectedContacts,
    openViewPopUp,
    setContactErrorMessage,
  } = props;

  const [searchName, setSearchName] = useState("");
  const [contactList, setContactList] = useState([]);
  const [loading, setLoading] = useState(false);

  const onNameChange = (e) => {
    setSearchName(e.target.value);
  };

  const searchEntity = () => {
    setLoading(true);
    axios
      .get(`/contacts?search=${searchName}&limit=-1&companyId=${companyId}`)
      .then((response) => {
        setContactList(response?.data?.contacts);
        setLoading(false);
      })
      .catch((error) => {
        setContactList([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    searchEntity();
  }, [searchName]);

  return (
    <>
      <Dialog width="40rem">
        <div>
          <HeaderWrapper>
            <Title>{t("QUOTE_ADD_CONTACT_TITLE")}</Title>
          </HeaderWrapper>
          <FormBody>
            <OptionsWrapper>
              <SectionContainer>
                <GridRow column="1fr">
                  <TextInput
                    id="search_contact"
                    type="text"
                    label={t("QUOTE_CONTACTS_SEARCH")}
                    isFloat
                    value={String(searchName)}
                    onChange={(e) => onNameChange(e)}
                    containerStyles={{ marginTop: "21px" }}
                    errorStyles={{ "font-style": "italic" }}
                    labelStyles={labelStyles}
                    inputStyles={inputStyles}
                    required
                    placeholder={t("QUOTE_CONTACTS_SEARCH")}
                  />
                </GridRow>
                {loading && (
                  <GridRow column="1fr">
                    <BarLoader width="100%" color="#1bace4" />
                  </GridRow>
                )}
                {contactList.length > 0 &&
                  contactList.map((contact, index) => {
                    return (
                      <RelatedContact
                        contactData={contact}
                        key={
                          "related_conatc_add" +
                          index +
                          contact?.id +
                          Math.random()
                        }
                        selectedContacts={selectedContacts}
                        setSelectedContacts={setSelectedContacts}
                        type="add"
                        setContactErrorMessage={setContactErrorMessage}
                      />
                    );
                  })}
              </SectionContainer>
            </OptionsWrapper>
          </FormBody>
          <ButtonWrapper>
            <Button
              styles={{
                color: "#fff",
                background: "#0A4986",
                border: "1px solid #0A4986",
                marginRight: "0.32rem",
                "&:hover": {
                  backgroundColor: "#0A4986",
                },
              }}
              onClick={openViewPopUp}
            >
              {t("ACTION_NEW_CONTACT")}
            </Button>

            <Button
              styles={{
                color: "white",
                background: "#ccc",
                border: "1px solid #ccc",
                marginRight: "0.32rem",
                "&:hover": {
                  backgroundColor: "#ccc",
                },
              }}
              onClick={onClose}
            >
              {t("CLOSE")}
            </Button>
          </ButtonWrapper>
        </div>
      </Dialog>
    </>
  );
};

AddRelatedContact.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
  isEditMode: PropTypes.bool,
};
AddRelatedContact.defaultProps = {
  id: null,
  isEditMode: false,
};

export default withTranslation()(AddRelatedContact);
